export const ru = {
    'internal-network': 'Внутренняя сеть',
    'invalid-url': 'Неправильный URL',
    'is-mobile': 'Мобильное устройство (isMobile)',
    'is-tablet': 'Планшет (isTablet)',
    'is-touch': 'Тач-устройство (isTouch)',
    'is-virused': 'Завирусованность',
    'is-yandex-plus': 'Яндекс Плюс',
    no: 'Нет',
    'not-selected': 'Не выбрано',
    yes: 'Да'
};
